import cn from 'classname';
import React from 'react';

const GropedByCell = (props) => {
	const { row_number, data, setActiveRow, activeRowNumber } = props;
	const { toggleUncoverByAdmin, toggleUncoverByAffiliate } = props;
	const { uncoveredAdmins, uncoveredAffiliates } = props;

	const offerGroupedByColData = data.offer ? `${data.offer}; ${data.country.toUpperCase()}` : null;
	const isGroupedByAdminRow = !data.affiliate_id && !data.offer_id;
	const isGroupedByAffiliateRow = data.affiliate_id && !data.offer_id;
	let toggleGroupingUncoverMethod = () => {};

	if (isGroupedByAdminRow) {
		toggleGroupingUncoverMethod = toggleUncoverByAdmin.bind(null, data.admin);
	}

	if (isGroupedByAffiliateRow) {
		toggleGroupingUncoverMethod = toggleUncoverByAffiliate.bind(null, data.affiliate_id);
	}

	if (!data)
		return null;

	return (
		<div
			className={cn({
				'table_cell': true,
				'expandable_cell': !!isGroupedByAdminRow || !!isGroupedByAffiliateRow,
				'active': row_number === activeRowNumber,
				'affiliate-row': data.affiliate_id && !data.offer_id,
				'offer-row': !!data.offer_id
			})}
			onMouseLeave={setActiveRow.bind(null, -1)}
			onMouseEnter={setActiveRow.bind(null, row_number)}
			onClick={toggleGroupingUncoverMethod}
		>
			{
				data.affiliate_id && !data.offer_id
					? <span className="affiliate_number">{`${props.affiliateRowId + 1})   `}</span>
					: null
			}

			{offerGroupedByColData || data.affiliate || data.admin}
			{
				(!!isGroupedByAdminRow || !!isGroupedByAffiliateRow) &&
				<span
					className={cn({
						'expand__icon': true,
						'expand__icon--opened': isGroupedByAdminRow && uncoveredAdmins.includes(data.admin)
							|| isGroupedByAffiliateRow && uncoveredAffiliates.includes(data.affiliate_id)
					})}
				/>
			}
		</div>
	);
};

export default GropedByCell;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-start/GroupedByCell.js